const normalizeValue = value => String(value ?? "").trim();

export const getFreeFormColumnAwareFields = fieldTemplate =>
  String(fieldTemplate || "")
    .split(/[|,]/)
    .map(field => field.replace(/[{}]/g, "").trim())
    .filter(Boolean);

export const isFreeFormColumnVisible = (column, formValues = {}) => {
  const configuration = column?.inputtable || {};

  if (String(configuration.bVisible) !== "true") return false;
  if (String(configuration.sColDataAware) !== "true") return true;

  const expectedValue = normalizeValue(configuration.sColVisibleValue);
  if (!expectedValue) return true;

  const awareFields = getFreeFormColumnAwareFields(
    configuration.sColDataAwareField
  );

  if (awareFields.length === 0) return false;

  return awareFields.some(fieldName =>
    normalizeValue(formValues?.[fieldName]) === expectedValue
  );
};
